import type { Node } from '@tiptap/pm/model'
import { NodeViewWrapper } from '@tiptap/react'
import clsx from 'clsx'
import React from 'react'

import { SpinnerIcon } from '@/components/shared/ui/Icons'

interface IPropTypes {
  node: Node
}
export default function EditorImageComponent(props: IPropTypes) {
  return (
    <NodeViewWrapper className='image-component p-1'>
      {props.node.attrs.uploadId ? (
        <div className='flex h-[400px] w-full flex-col items-center justify-center rounded-lg border border-gray7 bg-gray1'>
          <SpinnerIcon className='h-4 w-4 animate-spin' />
          <span className='pt-3 font-semibold'>Uploading...</span>
        </div>
      ) : (
        <img
          className={clsx('imgborder w-auto hover:cursor-zoom-in md:h-auto', {
            'max-h-[60vh]':
              !props.node.attrs['data-size'] ||
              props.node.attrs['data-size'] === 'auto',
          })}
          data-size={props.node.attrs['data-size']}
          src={props.node.attrs.src}
          alt={props.node.attrs.alt}
        />
      )}
    </NodeViewWrapper>
  )
}
